<script lang="ts">
  import Icon from '$shared/atoms/Icon/Icon.svelte';

  interface Props {
    checked?: boolean;
    disabled?: boolean;
    name: string;
    onchange?: (e: Event) => void;
  }

  let { checked = $bindable(false), disabled = false, name, onchange }: Props = $props();

  const stopClick = (e: MouseEvent): void => {
    e.stopPropagation();
  };
</script>

<div class="table-checkbox-cell" class:disabled onclick={stopClick}>
  <label for={name}>
    <input
      id={name}
      tabindex="1"
      bind:checked
      type="checkbox"
      hidden
      {disabled}
      onclick={stopClick}
      {onchange}
    />
    <div data-cy={name} class="fake-input">
      <div class="icon">
        <Icon value="icon-check white" size="14px" fontSize="14px" />
      </div>
    </div>
  </label>
</div>

<style>
  .table-checkbox-cell,
  .table-checkbox-cell label {
    display: flex;
    align-items: center;
  }
  .table-checkbox-cell label {
    cursor: pointer;
    height: 30px;
  }

  .table-checkbox-cell .fake-input {
    width: 16px;
    height: 16px;
    border: 1px solid #c6c9ce;
    box-shadow: 1px 2px 2px rgba(0, 0, 0, 0.02);
    border-radius: 3px;
    margin-right: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
  }
  .fake-input .icon {
    display: none;
    align-items: center;
    justify-content: center;
  }
  .table-checkbox-cell input:checked ~ .fake-input {
    border-color: var(--blue);
    background-color: var(--blue);
  }
  .table-checkbox-cell input:checked ~ .fake-input .icon {
    display: flex;
  }

  .table-checkbox-cell.disabled label {
    cursor: not-allowed;
  }
  .table-checkbox-cell.disabled input:checked:disabled ~ .fake-input {
    border-color: var(--grey-medium);
    background-color: var(--grey-medium);
  }
  .table-checkbox-cell.disabled input:not(:checked):disabled ~ .fake-input {
    background: #e8eaef !important;
    border: 1px solid #c6c9ce !important;
    box-shadow: 1px 2px 2px rgb(0 0 0 / 2%) !important;
    border-radius: 3px !important;
  }
</style>
